// @i18n-ignore-file
export const PAGE_TYPES = {
  COLLECTION: 'collection',
  SUBCOLLECTION: 'subcollection',
  PARTNER_PDP: 'partnerProduct',
  FAQ: 'faqPage',
  PRODUCT_AND_BUNDLE: 'product',
  LANDING: 'page',
  AUTH: 'authenticationPage',
  ACCOUNT: 'accountPage',
  HOME: 'homePage',
  SITE: 'site',
  SEARCH: 'search',
} as const

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES]
